
export class PedidoAlterarVendedorProduto {
    constructor(
        public produtosIds: string[] = [],
        public vendedorId: string = '',
        public vendedor: string = '',
    ) { }
}
